import React, { useEffect, useState } from "react";
import { Map } from "immutable";
import T from "prop-types";
import { Modal, Header, Close } from "MODULES/shared/components/Modal";
import * as actions from "MODULES/RepairOrders/actions";
import { ID } from "APP_ROOT/constants";
import api from "APP_ROOT/api";
import {
  REPAIR_EVALUATION_APPROVED,
  REPAIR_EVALUATION_REJECTED
} from "MODULES/inventories/constants";
import { removeKeys } from "LIB/removeKey";
import { APPROVAL_STATUSES, TEARDOWN } from "MODULES/RepairOrders/constants";
import Form from "./Form";

function EditEvaluationStatusModal({ close, repairOrder, visible }) {
  const [lineItems, setLineItems] = useState(null);
  const [itemsSelected, setItemsSelected] = useState([]);

  const approvalStatuses = Object.keys(
    removeKeys(APPROVAL_STATUSES, [
      REPAIR_EVALUATION_REJECTED,
      REPAIR_EVALUATION_APPROVED
    ])
  );

  useEffect(
    () => {
      api.repairOrders.lineItems
        .search(repairOrder.get(ID), {
          limit: 15,
          approval_status: approvalStatuses.join(","),
          shipped: true,
          simple_presenter: true
        })
        .then(({ data }) => {
          setLineItems(data.results);
          setItemsSelected(data.results.map(l => l.id));
          return function cleanup() {};
        });
    },
    [repairOrder.get(ID), visible]
  );

  if (!lineItems) return null;

  const js = repairOrder.toJS();
  js.line_items = lineItems.filter(
    l =>
      !l.cancelled &&
      ![REPAIR_EVALUATION_REJECTED, REPAIR_EVALUATION_APPROVED].includes(
        l.approval_status
      ) &&
      l.shipped
  );

  const hasTeardown = js.line_items.some(l => l.action_requested === TEARDOWN);

  return (
    <Modal open={visible} close={close} dialogClass="modal-lg">
      <Header>
        <Close close={close} />
        <h4 className="modal-title">Update Evaluation</h4>
      </Header>
      <Form
        close={close}
        hasTeardown={hasTeardown}
        repairOrder={js}
        initialValues={Object.assign(js, {
          approval_status: null,
          condition: null,
          tag_date: null,
          part_cost: null,
          labor_cost: null,
          transfer_cost: null,
          estimated_lead_time: null
        })}
        itemsSelected={itemsSelected}
        setItemsSelected={setItemsSelected}
        bulkUpdate={actions.bulkUpdateSelectedLineItems(itemsSelected)}
      />
    </Modal>
  );
}

export default EditEvaluationStatusModal;

EditEvaluationStatusModal.propTypes = {
  repairOrder: T.instanceOf(Map).isRequired
};



// WEBPACK FOOTER //
// ./app/modules/RepairOrders/components/Detail/UpdateEvaluationStatus/UpdateEvaluationStatusModal.jsx